import { ReactElement } from "react";
import { Button, VStack } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { BasicPageLayout } from "../../components/templates/BasicPageLayout";
import { ENABLED_ENGINES } from "../../environments";
import { useAtom } from "jotai";
import { contractEnginesAtom } from "../../store";
import { useModifiedTranslation } from "../../hooks/useModifiedTranslation";
import type { components } from "../../types/voislog_api";

type EngineType = components["schemas"]["EngineType"];

export function getSelectableEngineList(
  contractEngines: EngineType[],
): string[] {
  const ret = [] as string[];
  if (ENABLED_ENGINES.includes("Mi1") && contractEngines.includes("mi1"))
    ret.push("Mi1");

  return ret;
}

export function Engines(): ReactElement {
  const t = useModifiedTranslation();

  const [contractEngines] = useAtom(contractEnginesAtom);
  const url_list = getSelectableEngineList(contractEngines);

  return (
    <BasicPageLayout h="full">
      <VStack justify="center" h="full" gap={12}>
        {url_list.includes("Mi1") && (
          <Button
            as={Link}
            to="../Mi1/recording"
            width="full"
            variant="btn_primary"
            size="lg"
          >
            {t("EngineSelection.Mi1")}
          </Button>
        )}
      </VStack>
    </BasicPageLayout>
  );
}
